import { defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";

export const tableHeaderMessages = defineMessages({
  active: { id: "package.active", defaultMessage: "Active" },
  activeValue: { id: "app.active", defaultMessage: "Active" },
  inactiveValue: { id: "app.inactive", defaultMessage: "Inactive" },
  ticker: { id: "bundle.ticker.id", defaultMessage: "Id" },
  codesList: { id: "multiUpdateInventoryResultRenderer.valueType.codes", defaultMessage: "Codes" },
  name: { id: "package.name", defaultMessage: "Name" },
  extrasList: { id: "bundle.extras", defaultMessage: "Extras" },
  promotionsList: { id: "package.promotions", defaultMessage: "Promotions" },
  bundlePriceType: { id: "bundle.price.type", defaultMessage: "Rate Type" },
  travelWindowsList: {
    id: "inventoryTable.validitySection",
    defaultMessage: "Validity (Travel W)",
  },
  bookingWindowsList: { id: "bundle.booking.windows", defaultMessage: "Bookable (Booking W)" },
  minStay: { id: "bundle.short.minStay", defaultMessage: "Min. Stay (d)" },
  maxStay: { id: "bundle.short.maxStay", defaultMessage: "Max. Stay (d)" },
  minNotice: { id: "bundle.short.minNotice", defaultMessage: "Min. release (h)" },
  maxNotice: { id: "bundle.short.maxNotice", defaultMessage: "Max. release (h)" },
  closeToArrival: { id: "bundle.short.closeToArrival", defaultMessage: "CTA" },
  closeToDeparture: { id: "bundle.short.closeToDeparture", defaultMessage: "CTD" },
});

export const messages = {
  ...defaultCrudMessages,
  tableHeaders: tableHeaderMessages,
  entityName: {
    id: "package.entityName",
    defaultMessage: "Packages",
  },
  edit: {
    id: "app.entityForm.edit",
    description: "edit",
    defaultMessage: "edit",
  },
};

export const filterMessages = defineMessages({
  accommodation: {
    id: "app.smartSelector.filter.accommodation",
    defaultMessage: "Accommodation",
  },
  conditions: {
    id: "app.smartSelector.filter.conditions",
    defaultMessage: "Conditions",
  },
  ocupation: {
    id: "app.smartSelector.filter.configuration",
    defaultMessage: "Configurations",
  },
  mealplan: { id: "app.smartSelector.filter.mealplan", defaultMessage: "Meal Plan" },
});
